import React from 'react';
import Sidebar from 'components/modules/shipper/AdminSidebar';
export default function ShipperSettings({ userId, activePage }) {
    return React.createElement(Sidebar, { userId: userId, activePage: activePage });
}
